module.exports = __webpack_public_path__ + "static/media/default-peeping-face.c5da3f85.png";